import axios from '../utils/axios';

export default function anyJobseekerLogin(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/jobseeker-admin/v2/admin-recruiter/createseekertoken', data)
    )
}